import React from 'react';
import * as Styles from './CardProduct.styles';
import { Button } from 'gatorcomponents';
import { PRICE_SYMBOLS } from '../ProductsOffer/ProductsOffer.enum';
import { formatCurrency } from '@/utils/Formatters/formatCurrency';
import { COUNTRY } from '@/config';

const CardProduct = ({
  locale,
  image,
  title,
  tagLabel,
  tagVariant = 'success',
  description,
  discount,
  pricePrefix,
  price,
  priceSuffix,
  buttonPrimaryLabel,
  buttonPrimaryOnClick,
  buttonPrimaryVariant = 'primary',
  shouldShowButtonPrimary = true,
  buttonSecondaryLabel,
  buttonSecondaryOnClick,
  buttonSecondaryVariant = 'secondary',
  shouldShowButtonSecondary = false,
}) => (
  <Styles.CardProduct data-testid="card-product">
    <Styles.CardProductInner>
      <Styles.CardProductImageWrapper>
        <Styles.CardProductImage src={image} alt={title} />
      </Styles.CardProductImageWrapper>

      <Styles.CardProductBody>
        <Styles.CardProductTitle>{title}</Styles.CardProductTitle>
        <Styles.CardProductDescription>{description}</Styles.CardProductDescription>

        {discount && <Styles.ProductDiscountPrice>{discount}</Styles.ProductDiscountPrice>}
        {pricePrefix && <Styles.ProductPricePrefix>{pricePrefix}</Styles.ProductPricePrefix>}

        {price && (
          <Styles.WrapperPrice>
            <Styles.ProductSmallText>{locale.pricesText.priceSymbol}</Styles.ProductSmallText>
            <Styles.ProductPrice>{formatCurrency(price).replace(PRICE_SYMBOLS[COUNTRY.toLowerCase()], '')}</Styles.ProductPrice>
            {priceSuffix && <Styles.ProductSmallText>{priceSuffix}</Styles.ProductSmallText>}
          </Styles.WrapperPrice>
        )}
      </Styles.CardProductBody>

      <Styles.CardProductCtaWrapper>
        {shouldShowButtonPrimary && (
          <Button
            label={buttonPrimaryLabel}
            onClick={buttonPrimaryOnClick}
            size="large"
            variant={buttonPrimaryVariant}
            version="v2"
            width="full"
          />
        )}

        {shouldShowButtonSecondary && (
          <Button
            label={buttonSecondaryLabel}
            onClick={buttonSecondaryOnClick}
            size="large"
            variant={buttonSecondaryVariant}
            version="v2"
            width="full"
          />
        )}
      </Styles.CardProductCtaWrapper>
    </Styles.CardProductInner>

    {tagLabel && (
      <Styles.CardProductTag $variant={tagVariant}>
        {tagLabel}
      </Styles.CardProductTag>
    )}
  </Styles.CardProduct>
);

export default CardProduct;
